import Reveal from "@/components/Reveal";
import useSEO from "@/lib/useSEO";

const SECTIONS = [
  {
    title: "What's ours",
    body: "The FLEECE THE REGIME name, the star-mark logo, this website's design, and the specific artwork compositions on each garment (layout, lettering, texture, and print treatment) are our original work and our property. Don't reproduce them, don't screenshot-and-reprint them, don't list them as your own.",
  },
  {
    title: "What's the culture's",
    body: "Some phrases we print — like \"No human is illegal\" — are part of the long, proud tradition of protest language. Nobody owns them, including us, and that's the point. What we own is our particular artwork: the way the words are drawn, set, distressed, and printed. Copy the sentiment all you like (we encourage it). Copy our artwork and we'll send a very politely worded legal letter.",
  },
  {
    title: "Satire & parody",
    body: "Everything on this site is political satire and parody, which is protected speech. We punch up at power, never down at people. Any resemblance to actual policies, orange-hued public figures, or authoritarian enablers is entirely intentional.",
  },
  {
    title: "Protecting the brand",
    body: (
      <>
        FLEECE THE REGIME is our trademark-in-progress. If you see someone selling knockoffs of our designs, tell us at{" "}
        <a href="mailto:yell@fleecetheregime.com" className="font-bold text-black underline underline-offset-2 hover:text-primary transition-colors">
          yell@fleecetheregime.com
        </a>{" "}
        and we'll buy you a coffee (location permitting) while our lawyers warm up.
      </>
    ),
  },
  {
    title: "Orders, production & returns",
    body: "Every piece is printed to order and payment is processed by Stripe at checkout; production takes 2–7 business days (including the personal review every order gets before it prints), then tracked US shipping ($4.95 for the first item, $1.95 per extra item; the first item ships free on orders of $65 or more) — 4 to 12 business days door to door, matching the estimate shown at Stripe checkout. Changed your mind? Every order waits for a personal review before it is released to the printer — email yell@fleecetheregime.com with your order number during that window and we cancel and refund in full; once an order is printing it cannot be cancelled. Misprints or defects: free replacement or refund within 30 days of delivery — email your order number and clear photos of the problem; we cover any return shipping, and often a photo is enough so nothing needs mailing back. Wrong size: email within 30 days; we review those requests case by case — if we ask for the shirt back we'll tell you who covers postage before you ship. Approved refunds go back to the original payment method and typically appear within 5–10 business days. Every email gets a human reply within 24 hours.",
  },
  {
    title: "The honest fine print",
    body: "Unisex tees are printed on 6.1 oz garment-dyed heavyweight cotton (Comfort Colors 1717), women's relaxed tees on 4.3 oz combed ring-spun cotton (Next Level NL3910), fitted baby tees on 5.3 oz micro-rib (Bella+Canvas 1010), and hoodies on 340 gsm heavyweight fleece (Lane Seven LS19001). What we advertise is what ships. Product photos on this site are artist's mockups; the print close-up on each product page is real production artwork.",
  },
];

export default function Terms() {
  useSEO(
    "Terms & Intellectual Property | Fleece The Regime",
    "Our terms of service and IP policy: what we own, what belongs to the culture, our satire stance, and fabric honesty.",
    false,
    "/terms/"
  );
  return (
    <main data-testid="terms-page" className="pt-16 min-h-screen">
      <section className="px-6 sm:px-12 lg:px-20 pt-20 pb-14 border-b-2 border-black">
        <p className="font-mono text-xs font-bold uppercase tracking-[0.3em] text-primary mb-6">Terms & Intellectual Property</p>
        <h1 className="font-display uppercase text-6xl sm:text-7xl lg:text-8xl leading-[0.85] tracking-tighter" data-testid="terms-heading">
          Hands off<br />our <span className="text-primary">artwork.</span>
        </h1>
        <p className="mt-8 max-w-xl font-mono text-sm leading-relaxed text-black/60">
          The short version: the jokes belong to the people, the artwork belongs to us. The slightly longer version is below.
        </p>
      </section>
      <section className="px-6 sm:px-12 lg:px-20 py-16 max-w-5xl">
        {SECTIONS.map((s, i) => (
          <Reveal key={s.title} delay={i * 0.05}>
            <div className="border-t-2 border-black py-10" data-testid={`terms-section-${i}`}>
              <h2 className="font-display uppercase text-2xl sm:text-3xl tracking-tight">
                <span className="text-primary mr-4">{String(i + 1).padStart(2, "0")}</span>
                {s.title}
              </h2>
              <p className="mt-4 max-w-2xl font-mono text-sm leading-relaxed text-black/70">{s.body}</p>
            </div>
          </Reveal>
        ))}
        <p className="mt-10 font-mono text-xs text-black/40 leading-relaxed">
          This page is store policy, not legal advice. For the real thing, talk to an IP attorney — preferably one with a sense of humor.
        </p>
      </section>
    </main>
  );
}
